module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit/thumbnail_Keisuke Awazu-f0d3a0c88073a87639145898a01465fa.png";